import axiosInstance from "../../api/axios";

// Brand List
export const getBrands = async () => {
  try {
    const response = await axiosInstance.get(`/brands/list/`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Brand Create
export const createBrand = async (brandData: { name: string }) => {
  try {
    const response = await axiosInstance.post(`/brands/`, brandData);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Brand Update
export const updateBrand = async (id: number, brandData: { name: string }) => {
  try {
    const response = await axiosInstance.put(`/brands/${id}`, brandData);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Brand By ID
export const getBrandById = async (id: number) => {
  try {
    const response = await axiosInstance.get(`/brands/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Brand Delete
export const deleteBrand = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/brands/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};